import { AppState } from 'Store'

const selectChannels = (state: AppState) => state.chat.chatSocket.channels
const selectPrevPing = (state: AppState) => state.chat.chatSocket.prevPing
const selectCurrentPing = (state: AppState) => state.chat.chatSocket.currentPing
const selectHasWorker = (state: AppState) => state.chat.chatSocket.hasWorker
const selectSubscription = (state: AppState) => state.chat.chatSocket.subscription

export const chatSocketSelector = {
	selectChannels,
	selectPrevPing,
	selectCurrentPing,
	selectHasWorker,
	selectSubscription,
}
